'use strict';

angular.module('shiftTraderApp')
    .directive('saSlideSwipe', function() {
      return {
        template: '<div class="slide_swipe" ng-transclude></div>',
        require: '^saSlideSwipeContainer',
        transclude: true,
        replace: true,
        link: function(scope, element, attr, ctrl) {
          console.log('LINK: saSlideSwipe @ ' + attr.identifier);
          console.log(ctrl);
          scope.name = attr.identifier;

          ctrl.registerSlide({
            element: element,
            scope: scope,
            name: scope.name
          });

        }
      };
    });
